/**
 * The calendar's scope on the link — `?country=` (the market, `../data-schedules.ts`) and `?year=`
 * (CLAUDE.md §3.4, ADR 9068). Neither is defaulted: a calendar of the wrong year is a plan nobody
 * asked to read, so the page says «choose a year» until one is on the link. Pure.
 */

import { useEffect, useMemo, useState } from 'react';

export const YEAR_PARAM = 'year';

/** The bounds the platform reads a calendar for (`FIRST_YEAR`, `LAST_YEAR`). */
const FIRST_YEAR = 2020;
const LAST_YEAR = 2100;

/** The year a search string names, or `null`. */
export function readYear(search: string): number | null {
  const raw = new URLSearchParams(search).get(YEAR_PARAM)?.trim() ?? '';
  if (!/^\d{4}$/.test(raw)) return null;
  const year = Number(raw);
  return year >= FIRST_YEAR && year <= LAST_YEAR ? year : null;
}

/** The linked year, following browser back and forward. */
export function useYearScope(): number | null {
  const [, setNavigations] = useState(0);
  useEffect(() => {
    const onPopState = (): void => setNavigations((count) => count + 1);
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);
  const search = typeof window === 'undefined' ? '' : window.location.search;
  return useMemo(() => readYear(search), [search]);
}
